module.exports = __webpack_public_path__ + "img/hb_over.40dcd05b.png";